import React, { useEffect, useState } from 'react'

// next components

// components
import LoadingModal from 'components/Modal/LoadingModal'

// styles
import styles from './index.module.scss'

// redux

// solana
import { useMetaplex } from 'hooks/useMetaplex'
import { getMyCollections } from 'utils/collection.util'
import NoDataSection from '../NoDataSection'
import LoadingComponent from 'pages/explore/LoadingComponent'
import { NftData } from 'types/nft'
import CollectionCard from 'components/Card/CollectionCard'

const MyCollectionSection = () => {
  const [collections, setCollections] = useState([])
  const [isCollectionLoaded, setIsCollectionLoaded] = useState(false)
  const { metaplex: mx } = useMetaplex()
  const [rowCount, setRowCount] = useState(12)
  const [isFetching, setIsFetching] = useState(false)
  const [isVisibleFetching, setIsVisibleFetching] = useState(false)
  const [myCollections, setMyCollections] = useState<NftData[]>([])
  useEffect(() => {
    const getCollections = async () => {
      const collections = await getMyCollections(mx)
      let publicKey = mx.identity().publicKey
      setCollections(collections.filter(({ updateAuthorityAddress }) => updateAuthorityAddress?.equals(publicKey)))
      setIsCollectionLoaded(true)
    }
    if (mx) getCollections()
  }, [mx])

  useEffect(() => {
    if (collections.length > 0) {
      setMyCollections(collections.slice(0, rowCount))
      if (collections.length > rowCount) setIsVisibleFetching(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [collections])

  useEffect(() => {
    if (isFetching) {
      setIsFetching(false)
      if (myCollections.length + rowCount > collections.length) {
        setMyCollections([...myCollections, ...collections.slice(myCollections.length, collections.length)])
        setIsVisibleFetching(false)
      } else {
        setMyCollections([
          ...myCollections,
          ...collections.slice(myCollections.length, myCollections.length + rowCount),
        ])
        setIsVisibleFetching(true)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFetching])

  return (
    <section className={styles.container}>
      <div className="w-full mt-[15px] lg:mt-[0px] gap-[11px] 2xl:gap-[60px] lg:gap-[32px] grid grid-cols-12">
        {isCollectionLoaded &&
          myCollections.map((item, index) => (
            <div className="col-span-12 lg:col-span-4 2xl:col-span-3" key={index}>
              <CollectionCard
                image={item.json?.image}
                nftName={item.json?.name}
                artistName={item.creators[0]?.address.toString()}
                collectionId={item.mintAddress.toString()}
              />
            </div>
          ))}
      </div>
      {isCollectionLoaded && isVisibleFetching && (
        <div className="w-full mt-[-50px] mb-[40px]">
          <LoadingComponent isFetching={isFetching} setIsFetching={setIsFetching} />
        </div>
      )}
      <div className="col-span-12">
        <LoadingModal open={!isCollectionLoaded} />
      </div>
      {isCollectionLoaded && collections.length === 0 && (
        <div className="mt-[30px] lg:mt-[100px]">
          <NoDataSection
            title="No collections were created"
            description="This tab displays the collections you have created on Foster Marketplace"
          />
        </div>
      )}
    </section>
  )
}

export default MyCollectionSection
